module.exports = __webpack_public_path__ + "static/media/toshiba_nexus.bded6c0e.jpg";